import { processResponse, timeoutFetch } from 'Fetch';

let config = {
  gateway: null,
  json: true,
  method: 'GET',
  restAuth: null,
  reviewsApi: null,
  wordpressApi: null,
};

const returnJsonResult = async (res) => {
  const json = await res.json();
  if (!res.ok) {
    throw json;
  }
  return json;
};

export const getBrands = async () => {
  const res = await timeoutFetch(`${config.gateway}/platform/makes`);
  return returnJsonResult(res);
};

export const sendSms = (enquiryId, user) => { // eslint-disable-line
  return fetch(`${config.gateway}/platform/send-sms`, {
    body: JSON.stringify({ enquiryId }),
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': user.auth_token,
      'x-mway-requester': 'motorway-seller-webapp',
      ...(user?.cognitoTokens?.idToken && {
        'x-mway-authorization': user.cognitoTokens.idToken,
      }),
    },
    method: 'POST',
  }).then(processResponse);
};

export const init = (params) => {
  config = Object.assign(config, params);
};
